module.exports = __webpack_public_path__ + "static/media/G1-26-Kynthia-Cali-cod57.0370e8a9.png";